import { render, staticRenderFns } from "./RightsMenu.vue?vue&type=template&id=19f99088&scoped=true&"
import script from "./RightsMenu.vue?vue&type=script&lang=js&"
export * from "./RightsMenu.vue?vue&type=script&lang=js&"
import style0 from "./RightsMenu.vue?vue&type=style&index=0&id=19f99088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f99088",
  null
  
)

export default component.exports